module.exports = __webpack_public_path__ + "img/BSiegeTower64_ua.95f21bc2.webp";